import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-row-with-three-columns',
  templateUrl: './row-with-three-columns.component.html',
  styleUrls: ['./row-with-three-columns.component.scss'],
})
export class RowWithThreeColumnsComponent {
  @Input() breakpointSecondColumn: Observable<boolean>;
  @Input() breakpointThirdColumn: Observable<boolean>;

  @Input() rowFxLayoutAlign = 'center center';
  @Input() fxLayoutGap = '0px';

  @Input() column1FxLayoutAlign = 'center center';
  @Input() column2FxLayoutAlign = 'center center';
  @Input() column3FxLayoutAlign = 'center center';

  @Input() column1FxFlex = '33.33%';
  @Input() column2FxFlex = '33.33%';
  @Input() column3FxFlex = '33.33%';

  @Input() revertOrderOnBreakpoint = false;
}
